<div class="main-container">
    <div>
        <div class="radio-button-container">
            <p-radioButton label="Bookings" name="chartOption" value="1" [(ngModel)]="salesReportService.selectedChartOption" (onClick)="changeValue()"></p-radioButton>
            <p-radioButton label="Duration" name="chartOption" value="2" [(ngModel)]="salesReportService.selectedChartOption" (onClick)="changeValue()"></p-radioButton>
        </div>
        <table class="result-table">
            <tr>
                <th></th>
                <th colspan="2">{{tableTitle}}</th>
            </tr>
            <tr>
                <th>Week</th>
                <th>{{salesReportService.lastYear}}</th>
                <th>{{salesReportService.thisYear}}</th>
            </tr>
            <tr *ngFor="let record of salesReportService.weekRecordList">
                <td>
                    {{record.weekNum}}
                </td>
                <td>
                    {{record.valueLastYear}}
                </td>
                <td>
                    {{record.valueThisYear}}
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="salesReportService.data && salesReportService.data.datasets && salesReportService.data.datasets.length > 0">
        <p-chart #chart type="line" [data]="salesReportService.data" width="700px" height="500px"
            [responsive]="false"></p-chart>
    </div>
    <div>
        <p>
            Week: {{salesReportService.lastWeekNum}}
        </p>
        <table>
            <tr>
                <th></th>
                <th colspan="4">Year</th>
            </tr>
            <tr>
                <th></th>
                <th colspan="2">{{salesReportService.lastYear}}</th>
                <th colspan="2">{{salesReportService.thisYear}}</th>
            </tr>
            <tr>
                <th>Agent</th>
                <th>Bkg</th>
                <th>Weeks</th>
                <th>Bkg</th>
                <th>Weeks</th>
            </tr>
            <tr *ngFor="let agent of salesReportService.salesAgentsWeeklyResult">
                <td>{{agent.salesAgentName}}</td>
                <td>{{agent.lastYearBookings}}</td>
                <td>{{agent.lastYearDuration}}</td>
                <td>{{agent.thisYearBookings}}</td>
                <td>{{agent.thisYearDuration}}</td>
            </tr>
        </table>
    </div>
    <div>
        <p>
            Week: 1 - {{salesReportService.lastWeekNum}}
        </p>
        <table>
            <tr>
                <th>

                </th>
                <th colspan="2">
                    {{salesReportService.lastYear}}
                </th>
                <th colspan="2">
                    {{salesReportService.thisYear}}
                </th>
            </tr>
            <tr>
                <th></th>
                <th>
                    Bkgs
                </th>
                <th>
                    Weeks
                </th>
                <th>
                    Bkgs
                </th>
                <th>
                    Weeks
                </th>
            </tr>
            <tr *ngFor="let data of salesReportService.cumulativeWeeklyDataSet">
                <td>
                    {{data.salesAgentName}}
                </td>
                <td>
                    {{data.bookingsLastYear}}
                </td>
                <td>
                    {{data.weeksLastYear}}
                </td>
                <td>
                    {{data.bookings}}
                </td>
                <td>
                    {{data.weeks}}
                </td>
            </tr>
        </table>
    </div>
    <div>
        <p>
            Total
        </p>
        <table>
            <tr>
                <th>Total Bookings</th>
                <th colspan="3">Year</th>
            </tr>
            <tr>
                <th>Agent</th>
                <th>{{salesReportService.lastYear-1}}</th>
                <th>{{salesReportService.lastYear}}</th>
                <th>{{salesReportService.thisYear}}</th>
            </tr>
            <tr *ngFor="let agent of salesReportService.salesAgentTotals">
                <td>{{agent.salesAgentName}}</td>
                <td>{{agent.totalTwoYearsAgo}}</td>
                <td>{{agent.totalLastYear}}</td>
                <td>{{agent.totalThisYear}}</td>
            </tr>
        </table>
    </div>
</div>